export interface ITab {
  title: string;
  link?: string;
  id?: number | string;
  icon?: ITabIcon;
  open?: boolean;
  visible?: boolean;
}

interface ITabIcon {
  url: string;
  color: string;
  width: string;
  height: string;
  class?: string;
  action?: boolean;
}

export enum TransferTabs {
  Andamento = 'em andamento',
  NotaFiscal = 'solicitado',
  IntegradoSAP = 'liberado'
}

export enum ContractTabs {
  Aprovacao = 1
}

export enum TransferFragment {
  Invoice = 'invoice',
  SAP = 'sap'
}
